import Vue from 'vue';
import App from '/equipment/app.vue';

document.addEventListener('DOMContentLoaded', function(){
  new Vue({
    el: '#equipment-component',
    component: App,
    render: function(h){
      return h(App);
    }
  });
});
